<div class="source-container">
  <mode-code-highlight *ngIf="isRawQuery" [lang]="'sql'" [lineNumbers]="true"
  [query]="rawQuery"></mode-code-highlight>
  <mode-code-highlight *ngIf="!isRawQuery" [lang]="'sql'" [lineNumbers]="true"
  [query]="renderedQuery"></mode-code-highlight>
</div>
<footer mode-tab-footer>
  <div *ngIf="connectionName"><label>Connection name</label>{{ connectionName }}</div>
  <div *ngIf="connectionType"><label>Type</label>{{ connectionType | titlecase }}</div>
</footer>
